<template>
  <div class="tabs-container" v-if="!isTranscriptionStart && summaryStatus === 'ready'">
    <div class="custom-tabs">
      <button class="tab-item" :class="{ active: activeTab === 'summary' }" @click="handleTabClick('summary')">
        Resumo
      </button>
      <!-- <div class="tab-item-wrapper">
        <button 
          class="tab-item disabled"
          disabled
        >
          Transcrição
        </button>
        <span class="tooltip">Em breve</span>
      </div> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
  initialContext: {
    type: Object,
    required: true,
  },
  isTranscriptionStart: {
    type: Boolean,
    default: false,
  },
  summaryStatus: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["tabChanged"]);

const activeTab = ref("summary");

const handleTabClick = (tab: string) => {
  activeTab.value = tab;
  emit("tabChanged", tab);
};
</script>

<style scoped lang="scss">
.tabs-container {
  position: sticky;
  top: 0;
  z-index: 999;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  padding: 12px;
  padding-bottom: 0px;
  width: 100%;
  box-sizing: border-box;
}

.custom-tabs {
  display: flex;
  gap: 0;
}

.tab-item {
  padding: 10px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;

  &:hover:not(.disabled) {
    color: #059669;
  }

  &.active {
    color: #059669;
    border-bottom-color: #059669;
  }

  &.disabled {
    color: #9ca3af;
    cursor: not-allowed;
    opacity: 0.7;
  }
}

.tab-item-wrapper {
  position: relative;
  display: inline-flex;

  &:hover .tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
  }
}

.tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background: #1f2937;
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 99999999;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: #1f2937;
  }
}
</style>
